import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import Reveal from './Reveal.jsx';

const Section = styled.div`
  padding: 70px 100px;
  border-top: 2px solid ${theme.border};
  @media (max-width: 900px) {
    padding: 50px 24px;
  }
`;
const Label = styled.div`
  font-family: ${theme.fontMono};
  font-size: 13px;
  letter-spacing: 0.08em;
  color: ${theme.accent};
  text-transform: uppercase;
  margin-bottom: 36px;
`;
const Row = styled.div`
  display: flex;
  gap: 40px;
  padding: 22px 0;
  border-top: 1px solid ${theme.border};
  border-bottom: ${(p) => (p.$last ? `1px solid ${theme.border}` : 'none')};
  @media (max-width: 700px) {
    flex-direction: column;
    gap: 12px;
  }
`;
const Employer = styled.div`
  flex: 0 0 300px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${theme.fontHeading};
  font-weight: 800;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  @media (max-width: 700px) {
    flex: none;
  }
`;
const Meta = styled.span`
  color: ${theme.textDim};
  font-weight: 400;
  text-transform: none;
`;
const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${(p) => p.color};
  display: inline-block;
  ${(p) => p.$pulse && 'animation: pulse 2s ease-in-out infinite;'}
`;
const Clients = styled.div`
  flex: 1;
  font-family: ${theme.fontHeading};
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
  color: #D7D7DC;
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
`;
const Sep = styled.span`
  color: ${theme.accent};
`;

function List({ items }) {
  return (
    <Clients>
      {items.map((c, i) => (
        <React.Fragment key={c}>
          <span>{c}</span>
          {i < items.length - 1 && <Sep>&middot;</Sep>}
        </React.Fragment>
      ))}
    </Clients>
  );
}

export default function TimeLine() {
  return (
    <Section id="TrustedBy">
      <Label>Worked With</Label>

      <Reveal>
        <Row>
          <Employer><Dot color={theme.accent} $pulse />Full Stack (Pty) Ltd <Meta>&mdash; current</Meta></Employer>
          <List items={['Virgin Active', 'Travelstart', 'Ooba Home Loans', 'Buyers Trust']} />
        </Row>
      </Reveal>

      <Reveal delay="0.06s">
        <Row>
          <Employer><Dot color="#3A3A42" />Hyperboliq <Meta>&mdash; 2021&ndash;2023</Meta></Employer>
          <List items={['Kia Motors', 'Renault Motors', 'Motus Renault', 'GAMEON', 'USN', 'Tribeca', 'VTS', 'MDH Digital']} />
        </Row>
      </Reveal>

      <Reveal delay="0.12s">
        <Row>
          <Employer><Dot color="#3A3A42" />Freelance <Meta>&mdash; Odinsgate Media</Meta></Employer>
          <Clients>Kkwe Events</Clients>
        </Row>
      </Reveal>

      <Reveal delay="0.18s">
        <Row $last>
          <Employer><Dot color="#3A3A42" />Digitas Liquorice <Meta>&mdash; 2019&ndash;2020</Meta></Employer>
          <List items={['Ola Barbie Campaign', 'PurityApp', 'Engine', 'WhatsForDinner', 'Unilever Health', 'Unilever Hygienica', 'Knorr', 'Bright Future']} />
        </Row>
      </Reveal>
    </Section>
  );
}
